import {mapState, mapMutations,mapActions } from 'vuex'
export default {
    computed: {
		...mapState('help', ['qualificationIsAddFlag'])
    },
    methods: {
        ...mapActions('help', ['qualificationIsAdd']),
        ...mapMutations('help', ['changeQualificationIsAdd']),
        async testIsAddProduct() {
            let flag = true
            if(this.qualificationIsAddFlag !== 1 && this.staticPath === '/') {
                let res = await this.getQualificationIsAdd()
                if(res !== 1) {
                    res === -1 || res === -2 ? this.$confirm('没有添加对应资质，或已添加资质正在审核中/审核失败', '提示', {
                        confirmButtonText: '去添加',
                        showCancelButton: false,
                        closeOnClickModal: false,
                        closeOnPressEscape: false,
                        type: 'warning'
                    }).then(() => {
                        this.$router.push(this.staticPath + 'qualifications')
                    }) : this.$message({
                        message: '当前课程未关联分类',
                        type: 'error',
                        duration: 3000
                    })
                    flag = false
                } else {
                    this.changeQualificationIsAdd({isadd: res})
                }
            }
            return flag
        },
        async getQualificationIsAdd() {
            let res = await this.qualificationIsAdd()
            return res.isadd
        }
    }
}